module.exports = __webpack_public_path__ + "img/bus_02.be55b974.jpg";